export const pancardValidation = (text) => {
    let regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if(regex.test(text)) {
        return true;
    }
    return false;
}

export const nameValidation =/^[A-Za-z{" "}]+$/;
export const pan =/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

export const  validation = {
    nameValidation :/^[A-Za-z{" "}]+$/,
    pan :/^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/,
    text_number:/^[A-Za-z0-9{" "}]+$/,
    
}